export default __webpack_public_path__ + "static/media/PortraitThree.59a5c92c.jpg";